import { useFormContext, useController } from "react-hook-form";
import { PatternFormat } from "react-number-format";
import { useSelector } from "react-redux";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import PropTypes from "prop-types";
import Iconify from "../../../../../reusable-components/iconify";
import { formStyle } from '../../TransitionStyles';

PhoneNumberInput.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
}

export default function PhoneNumberInput({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name: fieldName, control });
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  return <PatternFormat
    inputRef={field.ref}
    key={field.id}
    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }}
    onFocus={() => setFocusedField(fieldName)}
    onBlur={() => setFocusedField(null)}
    customInput={TextField}
    format="###-###-####"
    mask="_"
    fullWidth
    disabled={!fieldAttributes.isEditable || isCanceled}
    size="small"
    error={!!fieldState.error}
    helperText={fieldState.error?.message}
    onChange={e => field.onChange(e.target.value)}
    value={field.value ?? ''}
    sx={formStyle}
    InputProps={{
      sx: { background: 'white' },
      endAdornment: (
        field.value && focusedField === fieldName ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onMouseDown={e => {
                e.preventDefault();
                field.onChange('');
              }}
              edge="end"
              tabIndex={-1}
            >
              <Iconify icon="eva:close-outline" />
            </IconButton>
          </InputAdornment>
        ) : null
      ),
    }}
  />
}
